import styled, { css } from 'styled-components'

export interface RangeSeparatorStyledProps {
  $size?: 'small' | 'medium' | 'large'
}

const sizeStyles = {
  small: css`
    font-size: ${({ theme }) => theme.typography.fontSize.micro};
    padding: 0 ${({ theme }) => theme.spacing.micro};
  `,
  medium: css`
    font-size: ${({ theme }) => theme.typography.fontSize.small};
    padding: 0 ${({ theme }) => theme.spacing.small};
  `,
  large: css`
    font-size: ${({ theme }) => theme.typography.fontSize.body};
    padding: 0 ${({ theme }) => theme.spacing.default};
  `,
}

export const Separator = styled.span<RangeSeparatorStyledProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  line-height: 1;
  user-select: none;
  flex-shrink: 0;

  ${({ $size = 'medium' }) => sizeStyles[$size]}
`
